/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramProductsModeratorControllerAddFeaturesMutationRequest,
  TelegramProductsModeratorControllerAddFeaturesMutationResponse,
  TelegramProductsModeratorControllerAddFeaturesPathParams,
  TelegramProductsModeratorControllerAddFeatures401,
  TelegramProductsModeratorControllerAddFeatures404,
} from '../../types/TelegramProductsModeratorControllerAddFeatures.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramProductsModeratorAddFeatures } from '../../methods/telegramProductsModeratorAddFeatures.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramProductsModeratorAddFeaturesMutationKey = () =>
  [{ url: '/api/moderator/telegram/products/features/:id' }] as const;

export type TelegramProductsModeratorAddFeaturesMutationKey = ReturnType<
  typeof telegramProductsModeratorAddFeaturesMutationKey
>;

/**
 * {@link /api/moderator/telegram/products/features/:id}
 */
export function useTelegramProductsModeratorAddFeatures<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramProductsModeratorControllerAddFeaturesMutationResponse,
      ResponseErrorConfig<
        TelegramProductsModeratorControllerAddFeatures401 | TelegramProductsModeratorControllerAddFeatures404
      >,
      {
        id: TelegramProductsModeratorControllerAddFeaturesPathParams['id'];
        data: TelegramProductsModeratorControllerAddFeaturesMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramProductsModeratorControllerAddFeaturesMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramProductsModeratorAddFeaturesMutationKey();

  return useMutation<
    TelegramProductsModeratorControllerAddFeaturesMutationResponse,
    ResponseErrorConfig<
      TelegramProductsModeratorControllerAddFeatures401 | TelegramProductsModeratorControllerAddFeatures404
    >,
    {
      id: TelegramProductsModeratorControllerAddFeaturesPathParams['id'];
      data: TelegramProductsModeratorControllerAddFeaturesMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return telegramProductsModeratorAddFeatures(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
